module.exports = __webpack_public_path__ + "media/components/brandings/svgs/downloadLanding/branding-download-buttonbg-cfac28155b2bf57a0d881e8ed43ed248.svg";